import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: ({selected, orderable}) => ({
        flexContainer: {},
        container: {
            display: 'flex',
            alignItems: 'center',
            height: 'auto',
            padding: 'none',
            borderStyle: orderable ? 'solid' : 'dashed',
            borderWidth: selected ? '2px' : '1px',
            borderColor: selected ? 'stokkeCore.black' : 'stokkeGray.mid',
            borderRadius: 5,
            _hover: {
                borderWidth: '2px',
                borderColor: 'stokkeCore.black'
            },
            _active: {
                borderWidth: '2px',
                borderColor: 'stokkeCore.black'
            }
        },
        image: {
            color: 'grey'
        },
        label: {},
        count: {
            backgroundColor: 'stokkeGray.bright',
            borderRadius: '5px',
            paddingY: 0.5,
            paddingX: 1.5,
            marginStart: 2
        }
    }),

    variants: {
        refinementChip: {
            flexContainer: {
                flexGrow: 0,
                flexShrink: 0,
                flexBasis: {
                    base: '100%',
                    md: 'calc(50% - 6px)'
                },
                overflow: 'hidden'
            },
            container: {
                height: '4.125rem',
                width: '100%',
                maxWidth: '100%',
                display: 'flex',
                justifyContent: 'space-between',
                paddingRight: 2
            },
            image: {
                width: '3.125rem',
                minWidth: '3.125rem',
                height: '3.125rem',
                objectFit: 'cover',
                marginRight: 4
            },
            label: {
                whiteSpace: 'pre-wrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                sx: {
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical'
                },
                width: '100%',
                textAlign: 'start',
                paddingLeft: 0
            },
            count: {
                paddingLeft: 2
            }
        }
    },
    sizes: {
        sm: {
            container: {
                paddingLeft: 2,
                paddingRight: 4,
                height: 37,
                ...textStyles['Regular Small']
            },
            image: {
                boxSize: 6
            },
            label: {
                paddingLeft: 2
            }
        },
        md: ({leftIcon}) => {
            return {
                container: {
                    paddingLeft: leftIcon ? 6 : 3,
                    paddingRight: 6,
                    height: 45,
                    ...textStyles['Regular Medium']
                },
                image: {
                    boxSize: 6
                },
                label: {
                    paddingLeft: leftIcon ? 0 : 3
                }
            }
        }
    },
    defaultProps: {
        size: 'sm'
    },
    parts: ['container', 'image', 'label', 'flexContainer']
}
